<hawk-record-navigation
  class="common_style"
  [breadcrumbLinkList]="[]"
  [root]="'customer'"
  [leafDescription]="'Filialen'"
  class="app-page"
>
  <div slot="toolbar" class="flex flex-row gap-2">
    <a href="/a/filiale/neu" class="bm-btn bm-btn-ghost">
      <i class="fa fa-plus"></i>
      Filiale erstellen
    </a>
    <input type="text" class="bm-input" placeholder="Schnellfilter..." (input)="quickSearchChanged($event)" />
  </div>
  <div class="page-content px-4 pb-2">
    <ag-grid-angular
      class="ag-theme-quartz h-full"
      [rowData]="stores"
      [theme]="hawkTheme"
      [defaultColDef]="defaultColDef"
      [columnDefs]="colDefs"
      [rowClassRules]="rowClassRules"
      [pagination]="true"
      [rowSelection]="rowSelection"
      [autoSizeStrategy]="autoSizeStrategy"
      [paginationPageSize]="100"
      [localeText]="locale"
      [sideBar]="sideBarOptions"
      [paginationPageSizeSelector]="[25, 100, 250, 1000]"
      (gridReady)="onGridReady($event)"
    />
  </div>
</hawk-record-navigation>
